import React, { PropsWithChildren } from "react";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ReplayIcon from "@mui/icons-material/Replay";
import TuneIcon from "@mui/icons-material/Tune";

import { Button, ButtonBase } from "@mui/material";

import Form from "commons/ui/Form";
import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import IconText from "commons/ui/IconText";

type PropsType = {
    applyFilters: () => void;
    clearFilters: () => void;
    openDefault?: boolean;
    extraFilters?: React.ReactNode;
};

function FiltersContainer({
    applyFilters,
    clearFilters,
    openDefault = false,
    extraFilters,
    children,
}: PropsWithChildren<PropsType>) {
    const [showExtraFilters, setShowExtraFilters] = React.useState<boolean>(openDefault);

    const toggleShowExtraFilters = React.useCallback(
        () => setShowExtraFilters((prev) => !prev),
        []
    );

    return (
        <Form>
            <GridColumn className={"filters-container"}>
                <GridItem>
                    <GridRow alignItems={"center"}>
                        {children}

                        <GridItem className={"col-xs-auto"}>
                            <Button
                                className={"small-button"}
                                type={"submit"}
                                variant={"contained"}
                                color={"primary"}
                                onClick={applyFilters}
                            >
                                {"Cerca"}
                            </Button>
                        </GridItem>

                        <GridItem className={"col-xs-auto"} style={{ flex: "1" }}>
                            <ButtonBase className={"clear-filters"} onClick={clearFilters}>
                                <ReplayIcon titleAccess={"Cancella filtri"} />
                            </ButtonBase>
                        </GridItem>

                        {extraFilters ? (
                            <GridItem className={"col-xs-auto"}>
                                <Button
                                    className={"small-button extra-filters-button"}
                                    onClick={toggleShowExtraFilters}
                                    title={showExtraFilters ? "Chiudi filtri" : "Apri filtri"}
                                >
                                    <div style={{ flex: "1" }}>
                                        <IconText icon={<TuneIcon />} text={"FILTRI"} />
                                    </div>

                                    {showExtraFilters ? (
                                        <KeyboardArrowUpIcon />
                                    ) : (
                                        <KeyboardArrowDownIcon />
                                    )}
                                </Button>
                            </GridItem>
                        ) : null}
                    </GridRow>

                    {showExtraFilters ? (
                        <GridRow>
                            <GridItem className={"col-xs-12-12"}>
                                <div className={"extra-filters-container"}>{extraFilters} </div>
                            </GridItem>
                        </GridRow>
                    ) : null}
                </GridItem>
            </GridColumn>
        </Form>
    );
}

export default FiltersContainer;
